import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { LlttfInvitationFormComponent } from 'src/app/components/invitations/llttf-invitations/llttf-invitation-form/llttf-invitation-form.component';
import { LLTTFInvitationList } from 'src/app/components/invitations/llttf-invitations/llttf-invitation-list';
import { LLTTFInvitations, LLTTFInvitationsDefaultValue } from 'src/app/components/invitations/llttf-invitations/llttf-invitations';
import { LlttfInvitationService } from 'src/app/services/llttf-invitation.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-edit-llttf-invitation',
    templateUrl: './edit-llttf-invitation.component.html',
    styleUrls: ['./edit-llttf-invitation.component.scss'],
    standalone: false
})
export class EditLlttfInvitationComponent {
  llttfinvitation: LLTTFInvitations = LLTTFInvitationsDefaultValue();
  @ViewChild(LlttfInvitationFormComponent) llttfinvitationForm!: LlttfInvitationFormComponent;
  isSubmitted = false;
  id: string = '';
  hideForm = false;
  invitationLink: string = '';
  topmsg: string = '<strong>Cohort updated </strong>- Copy the invite link below to send to cohort participants.';
  pageName = CheckPageAccess.EDITLLTTFINVITATION;

  constructor(
    private _llttfinviteservice: LlttfInvitationService,
    private _toastservice: ToastService,
    private router: Router,
    private route: ActivatedRoute)
  { }

  ngOnInit(){
    this.route.params.subscribe((params) => {
      this.id = params['id'];
      this._llttfinviteservice.getLLTTFInvitationDetailsForUpdate(this.id).subscribe({
        next:(response) => {
          this.llttfinvitation = response;
          if (!this.llttfinvitation.languageId) {
            this.llttfinvitation.languageId = 1;
          }
        }
      });
    });
  }

  onSubmit() {
    this.isSubmitted = true;
    if (!this.llttfinvitationForm.validateReqFileds()) {
      this._toastservice.showErrorMessage('Please correct all the errors first.');
      return;
    }

    this.llttfinvitation.id = this.id;
    this._llttfinviteservice.updatellttfinvitation(this.llttfinvitation).subscribe({
      next: (response) => {
        if (response.status) {
          this._toastservice.showMessage("Invitation updated successfully");

          if (this.llttfinvitation.isActive) {
            this.hideForm = true;
            this.invitationLink = response.message;
            this.topmsg = "<strong>Cohort updated </strong>- Copy the invite link below to send to cohort participants.";
          }
          else {
            this.router.navigate(['/llttf-invite-list']);
          }
        }
        else {
          this._toastservice.showErrorMessage(response.message)
        }
      }
    })
  }
}
